import React from 'react';
import DOMPurify from 'dompurify';

function createMarkup(content) {
  return { __html: DOMPurify.sanitize(content.replaceAll('\n\n', '<br/>')) };
}

/**
 * Sanitizes and renders content as HTML.
 * This should be the only component that uses the dangerouslySetInnerHTML prop.
 * @param {Object} props
 * @param {string} props.content
 */
export default function HTML({ content }) {
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={createMarkup(content)} />;
}
